export const REGISTERED_AD_PLACEMENT = "REGISTERED_AD_PLACEMENT";
export const REMOVED_AD_PLACEMENT = "REMOVED_AD_PLACEMENT";
